const resourceDetailMutationKeys = {
  updateResourceLinkPreview: (resourceId) => [
    "update-resource-link-preview",
    resourceId
  ]
};

export { resourceDetailMutationKeys };
//# sourceMappingURL=resourceDetailMutationKeys.js.map
